

const NoAccountManagerPermsisonRoute = () => {

    return (
        <h2>No Account Manager Found, Please contact the admin to add account manager status</h2>
    )

}


export default NoAccountManagerPermsisonRoute;